import React, { useState, useEffect } from 'react';
import { CircularProgress, Box, Dialog, DialogActions, DialogContent, DialogTitle, Button, Grid, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from '@mui/material';
import { getIcon } from '../../../utils/IconHandler';
import { useTranslation } from 'react-i18next';
import { getTerminals, addTerminal, deleteTerminal } from '../../../services/LocationService'; // Importamos las llamadas API

const ManageTerminalsModal = ({ open, onClose, locationId }) => {
  const { t } = useTranslation();

  const [terminalList, setTerminalList] = useState([]);
  const [reference, setReference] = useState('');
  const [terminalCode, setTerminalCode] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && locationId) {
      const fetchTerminals = async () => {
        try {
          setLoading(true);
          const terminalsFromApi = await getTerminals(locationId);
          setTerminalList(terminalsFromApi);
        } catch (error) {
          console.error("Error fetching terminals:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchTerminals();
      setReference('');
      setTerminalCode('');
    }
  }, [open, locationId]);

  const handleAddTerminal = async () => {
    if (reference.trim() === '' || terminalCode.trim() === '') return;
    if (terminalList.some(terminal => terminal.code === terminalCode)) {
      alert(t('terminal_already_exists'));
      return;
    }
  
    try {
      const newTerminal = await addTerminal(locationId, { reference, code: terminalCode }); // Corrección
      setTerminalList([...terminalList, newTerminal]);
      setReference('');
      setTerminalCode('');
    } catch (error) {
      console.error("Error adding terminal:", error);
      alert(t('error_adding_terminal'));
    }
  };  

  const handleDeleteTerminal = async (locationId, code) => {
    try {
      await deleteTerminal(locationId, code);
      setTerminalList(terminalList.filter(terminal => terminal.code !== code));
    } catch (error) {
      alert(t('error_deleting_terminal'));
    }
  };  

  const handleSave = () => {
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('manage_terminals')}</DialogTitle>
      <DialogContent>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('terminal_reference')}</TableCell>
                <TableCell>{t('terminal_code')}</TableCell>
                <TableCell>{t('mp_pos_id')}</TableCell>
                <TableCell align="right">{t('actions')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Box py={0}>
                      <CircularProgress size={24} />
                    </Box>
                  </TableCell>
                </TableRow>
              ) : terminalList.length > 0 ? (
                terminalList.map((terminal, index) => (
                  <TableRow key={terminal.code || index}>
                    <TableCell>{terminal.reference || t('no_reference')}</TableCell>
                    <TableCell>{terminal.code || t('no_code')}</TableCell>
                    <TableCell>{terminal.mercadoPagoPosId || t('no_code')}</TableCell>
                    <TableCell align="right">
                      <IconButton onClick={() => handleDeleteTerminal(locationId, terminal.code)}>
                        {getIcon('trash')}
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <span style={{ color: "#888", fontStyle: "italic" }}>{t('no_terminals_available')}</span>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid container spacing={2} alignItems="center" style={{ marginTop: '10px' }}>
          <Grid item xs={5}>
            <TextField
              fullWidth
              label={t('terminal_reference')}
              value={reference}
              onChange={(e) => setReference(e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label={t('terminal_code')}
              value={terminalCode}
              onChange={(e) => setTerminalCode(e.target.value)}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <IconButton 
              onClick={handleAddTerminal} 
              color="primary"
              sx={{ backgroundColor: '#f0f0f0', borderRadius: '8px' }} 
            >
              {getIcon('add')}
            </IconButton>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={handleSave} variant="contained" color="primary">{t('save')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManageTerminalsModal;
